import React from 'react';
import { setUrlQueryParam } from '../../../../../../actions';
import { SignificantChangesPanel as SignificantChangesPanelComponent } from '../../../../../../components/SettingsPanel/subComponents';
import i18n from '../../../../../../i18n';

export default function SignificantChangesPanel({ urlParams, dispatch }) {
	let trends = null;
	const dropdowns = [
		{
			text: i18n.t('Significant Changes'),
			onChange: (value) => {
				dispatch({
					type: 'setUrlQueryParam',
					action: setUrlQueryParam({ name: 'significantChange', value: value }),
				});
			},
			options: ['95', '90', '85', '80'],
		},
	];

	return <SignificantChangesPanelComponent dropdowns={dropdowns} />;
}
